import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { appSettings } from 'app/appSettings';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { StockCountCreateOrder } from 'app/core/store/stock-count/stock-count.interface';
import { util } from '../../../../../../core/util/util';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-stock-count-order',
  templateUrl: './stock-count-order.component.html',
  styleUrls: ['./stock-count-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockCountOrderComponent implements OnChanges {
  checked = false;

  @Input() columns: {id: string, colName: string}[];
  @Input() order: StockCountCreateOrder;
  @Input() shipTos: Definition[];
  @Input() selectedOrders: string[];
  @Input() definitions: Definitions;

  @Output() checkboxChanged: EventEmitter<{ checked: boolean; order: StockCountCreateOrder }> = new EventEmitter();

  dateFormat: string = appSettings.DATE_FORMAT_ANGULAR;

  constructor(private datePipe: DatePipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedOrders) {
      this.checkIfSelected();
    }
    if (changes.order) {
      this.checked = this.order.includedInCount;
    }
  }

  renderColumn(columnId: string) {
    const value = this.order[columnId];
    if (!value) {
      return '';
    }
    switch (columnId) {
      case 'from':
      case 'to':
        return value.name;
      case 'date':
        return this.datePipe.transform(value, this.dateFormat);
      default:
        return value;
    }
  }

  /**
   * @deprecated use renderColumn which is a more generic name for what this function does
   * @param id
   * @param columnId
   * @param value
   */
  mapShipTos(id: string, columnId, value: any) {
    const isFromOrTo = columnId === 'from' || columnId === 'to';
    const isDate = columnId === 'requestedDeliveryDate';
    if (id && this.shipTos && isFromOrTo) {
      // map shipto's & froms
      const shipto = this.shipTos.find(shipto => util.toNumber(shipto.id) === util.toNumber(id));
      return shipto && shipto.name ? shipto.name : '';
    } else if (isDate && value) {
      // format date
      return this.datePipe.transform(value, this.dateFormat);
    } else {
      return value;
    }
  }

  checkIfSelected() {
    if (this.selectedOrders.indexOf(this.order.etmOrderNo) > -1) {
      this.checked = true;
    } else {
      this.checked = false;
    }
  }

  checkboxUpdate() {
    this.checkboxChanged.emit({
      checked: this.checked,
      order: this.order,
    });
  }
}
